import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import { Button } from '@/Components/shadcn';

interface ClearAllButtonProps {
    onClearAll: () => void;
}

const ClearAllButton = ({ onClearAll }: ClearAllButtonProps) => {
    return (
        <Button
            size="sm"
            variant="ghost"
            onClick={(e) => {
                e.preventDefault();
                onClearAll();
            }}
        >
            {UIStrings.ClearAll}
        </Button>
    );
};

export default ClearAllButton;
